import { $axios, useAuthTokenError, objectToUrlParams } from '../utils'
import { validateCreateTestimony } from '../validators/testimonies.validators'

/** Creates new testimony */
export const createTestimony = (payload) => {
  validateCreateTestimony(payload)

  return $axios('/testimonies', {
    method: 'POST',
    data: payload
  })
}

/** Gets all testimonies for authenticated */
export const getTestimonies = (authToken, query) => {
  useAuthTokenError(authToken)

  const queryString = objectToUrlParams(query)
  return $axios(`/testimonies?${queryString}`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/** Gets a single testimony */
export const getTestimony = (authToken, id) => {
  useAuthTokenError(authToken)

  return $axios(`/testimonies/${id}`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/** Updates a single testimony */
export const updateTestimony = (authToken, id, payload) => {
  useAuthTokenError(authToken)

  return $axios(`/testimonies?${id}`, {
    method: 'PUT',
    headers: {
      'x-access-token': authToken
    },
    data: payload
  })
}

/** Deletes a single testimony */
export const deleteTestimony = (authToken, id) => {
  useAuthTokenError(authToken)

  return $axios(`/testimonies?${id}`, {
    method: 'DELETE',
    headers: {
      'x-access-token': authToken
    }
  })
}
